import { EMPTY_ARRAY } from '~/src/Lib/Utils'

const CLEAR_SELECTED_ITEMS = 'INVENTORY_SELECTION_CLEAR_SELECTED_ITEMS'
const SET_SELECTED_ITEMS = 'INVENTORY_SELECTION_SET_SELECTED_ITEMS'

export default {
  name: 'inventorySelection',
  reducer: (state = EMPTY_ARRAY, action) => {
    if (action.type === SET_SELECTED_ITEMS) return action.payload
    if (action.type === CLEAR_SELECTED_ITEMS) return EMPTY_ARRAY
    return state
  },
  selectInventorySelectedItems: state => state.inventorySelection ?? EMPTY_ARRAY,
  doInventoryClearSelectedItems: () => ({ type: CLEAR_SELECTED_ITEMS }),
  doInventorySetSelectedItems: payload => ({ type: SET_SELECTED_ITEMS, payload }),
  persistActions: [SET_SELECTED_ITEMS, CLEAR_SELECTED_ITEMS],
}
